import { Component, input } from '@angular/core';
import { PmIconComponent } from '@libs/ui';
import { LucideGrip } from '@lucide/angular';

@Component({
  selector: 'pm-group-column-item',
  template: `
    <div
      class="flex flex-row self-start h-10 items-center gap-2 px-3 cursor-pointer border-border-subdued border rounded-lg"
    >
      <pm-icon size="xs" [icon]="dragHandleIcon" />
      <span class="text-xs text-content-interactive-subdued">
        {{ this.name() }}
      </span>
    </div>
  `,
  imports: [PmIconComponent],
})
export class GroupColumnItemComponent {
  name = input.required<string>();

  protected dragHandleIcon = LucideGrip;
}
